import React, { useRef } from 'react';
import type { ReactElement } from 'react';

interface DescriptionProps {
    text: string;
    textWrapper?: ReactElement;
}

const Description: React.FC<DescriptionProps> = ({ text, textWrapper }) => {
    const ref = useRef<HTMLInputElement>(null);
    if (!textWrapper && text.trim().length === 0) {
        return null;
    }

    return (
        <>
            {textWrapper
                ? React.cloneElement(textWrapper, {}, <p>{text}</p>)
                : <div ref={ref}> <p>{text}</p></div>
            }
        </>
    );
};

export default Description;
